__webpack_require__.p = "https://assets.production.decovostatic.com/next-static-live/gatoradeteamzone-frontend/_next/";